function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#6F7493;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_134",
  transform: "translate(-516 -239.184)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-link",
  transform: "translate(517 240.184)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_94"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.2,12C8.6,12,7,11.3,6,9.9C5.6,9.4,5.7,8.8,6.2,8.5c0.4-0.3,1.1-0.2,1.4,0.2c1.1,1.4,3.1,1.7,4.5,0.7 c0.1-0.1,0.2-0.2,0.3-0.3L15,6.5c0.6-0.6,0.9-1.4,0.9-2.3c0-0.9-0.3-1.7-0.9-2.3c-1.2-1.2-3.3-1.2-4.6,0L9,3.4 c-0.4,0.4-1,0.4-1.4,0C7.1,3,7.2,2.4,7.5,2L9,0.5c1-1,2.3-1.5,3.7-1.5c1.4,0,2.7,0.5,3.7,1.5s1.5,2.3,1.5,3.7 c0,1.4-0.5,2.7-1.5,3.7l-2.5,2.5c-0.2,0.2-0.4,0.3-0.6,0.5C12.3,11.6,11.2,12,10.2,12z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_95"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M4.2,17.9c-1.3,0-2.7-0.5-3.7-1.5c-2-2-2-5.4,0-7.4l2.5-2.5c0.2-0.2,0.4-0.3,0.6-0.5C5.9,4.2,9.2,4.7,11,7 c0.3,0.4,0.2,1.1-0.2,1.4c-0.4,0.3-1.1,0.2-1.4-0.2C8.3,6.8,6.3,6.5,4.8,7.6C4.7,7.6,4.6,7.7,4.5,7.9l-2.5,2.5 c-1.3,1.3-1.3,3.3,0,4.6c1.3,1.3,3.3,1.3,4.6,0L8,13.5c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-1.4,1.4C6.9,17.4,5.6,17.9,4.2,17.9z"
}))));

var SvgShareLink = function SvgShareLink(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.9 18.9",
    style: {
      enableBackground: "new 0 0 18.9 18.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share-link.aeca4530.svg";
export { ForwardRef as ReactComponent };